/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-logincallback',
  templateUrl: './logincallback.component.html',
  styleUrls: ['./logincallback.component.scss']
})
export class LogincallbackComponent implements OnInit {

  Message_PleaseWait: string = "Please wait...";
  Message_ConnectingToServer: string = "Connecting to server...";
  Message_ValidatingSession: string = "Validating session...";
  Message_UnableToProcessLogin: string = "Unable to process login.  Try again or contact support.";
  Message_PreparingSession: string = "Preparing session...";
  Message_LoadingPage: string = "Loading page...";
  processTimeout: number = 2 * 1000;
  showProgress: boolean = true;
  progressMessage: string = "";
  color: string = 'primary';
  mode: string = 'indeterminate';
  value: number = 50;

  getLoginService(): LoginService {
    return this.loginsvc;
  }

  constructor(private route: ActivatedRoute, private loginsvc: LoginService, private router: Router) {
    this.setProgress(this.Message_PleaseWait, 0);
  }

  ngOnInit() {
    this.setProgress(this.Message_ValidatingSession, 0);
    setTimeout(() => {
      let userInfo = this.loginsvc.GetSessionUserInfo();
      if (!this.loginsvc.IsSignedIn(userInfo))
        this.setProgress(this.Message_UnableToProcessLogin, 0);
      else
        this.setProgress(this.Message_LoadingPage, 0);

      setTimeout(() => {
        this.showProgress = false;
        window.location.href = this.loginsvc.app_path;
      }, 1000);
    }, this.processTimeout);
  }

  setProgress(msg, timeout) {
    if (msg == null || msg.length == 0) return;
    if (typeof timeout === 'number' && timeout >= 0) {
      setTimeout(() => {
        this.progressMessage = msg;
      }, timeout);
    }
  }

}
